import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22index.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./local-fonts/Gilroy-SemiBold.woff2%22,%22weight%22:%22600%22,%22style%22:%22normal%22},{%22path%22:%22./local-fonts/Gilroy-Bold.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22}]}],%22variableName%22:%22gilroyFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'gilroyFont', 'gilroyFont Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
